import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import OpalPresentationTable from '../../../../DenaliAnalysis/tables/presentation'
import { useColumns } from '../../../presentationTable/PipelinePresentationTable'

function ChildNodesTable ({ data, displayConfig }) {
  const visibleColumns = useMemo(() =>
    (displayConfig?.columns ?? []).filter(c => c.defaultShown !== false),
  [displayConfig?.columns])

  const { columns } = useColumns(visibleColumns)

  if (!columns?.length || !data?.length) return null

  return (
    <OpalPresentationTable
      data={data}
      columns={columns}
      includeHeader
      className='text-xs'
      componentStyles={{
        header: { padding: '4px 6px', fontSize: '0.6875rem' },
        cell: { padding: '4px 6px', fontSize: '0.6875rem' }
      }}
    />
  )
}

ChildNodesTable.propTypes = {
  data: PropTypes.array.isRequired,
  displayConfig: PropTypes.object
}

export default function ChildDataSection ({ raw, levelConfig, hiddenChildren }) {
  const childNodesDisplay = levelConfig?.childNodesDisplay
  if (!childNodesDisplay || childNodesDisplay.enabled === false) return null

  const accessor = childNodesDisplay.accessor ?? 'data'
  const childRows = hiddenChildren?.length ? hiddenChildren : get(raw, accessor)
  if (!Array.isArray(childRows) || !childRows.length) return null

  return (
    <div style={{ marginTop: 16 }}>
      {childNodesDisplay.label && (
        <div style={{ color: 'var(--color-neutral-500)' }}>
          {childNodesDisplay.label}
        </div>
      )}
      <ChildNodesTable data={childRows} displayConfig={childNodesDisplay} />
    </div>
  )
}

ChildDataSection.propTypes = {
  raw: PropTypes.object,
  levelConfig: PropTypes.object,
  hiddenChildren: PropTypes.array
}
